import { render, staticRenderFns } from "./CargoSpaceTakeInventoryResultForm.vue?vue&type=template&id=0afe5272"
import script from "./CargoSpaceTakeInventoryResultForm.vue?vue&type=script&lang=js"
export * from "./CargoSpaceTakeInventoryResultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports